import React, {useState} from 'react';
import axios from 'axios'
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    FormGroup,
    Label,
    Input,
    NavLink,
    Alert
} from 'reactstrap'

const RegisterModal = props => {
    const [modal, setModal] = useState()
    const [errorMessage, setErrorMessage] = useState('')
    const [email, setEmail] = useState('')
    const [name, setName] = useState('')
    const [password, setPassword] = useState('')
    const [password2, setPassword2] = useState('')

    // Function to open and close login modal
    const toggle = () => {
        setModal(!modal)
    }

    // Login Function
    const submitRegister = async e => {
        e.preventDefault()
        const registerDetails = {
            name,
            email,
            password,
            password2
        }
        await axios.post('api/auth/register',registerDetails)
        .then(res => {
            toggle()
            localStorage.setItem('token', res.data.token)
            props.setAuthenticated(true)
        })
        .catch(err => {
            localStorage.clear()
            setErrorMessage(err.response.data.message)
        })
    }

        return (
            <div>
                <NavLink
                    className={props.triggerClassName || 'auth-nav-link auth-nav-link--primary'}
                    onClick={toggle}
                    href = "#"
                >
                    {props.label || 'Register Here'}
                </NavLink>

                <Modal
                    className='fobk-modal'
                    isOpen={modal}
                    toggle={toggle}
                >
                    <ModalHeader
                        toggle={toggle}
                    >
                        Register
                    </ModalHeader>
                    <ModalBody>
                        <p>Create an FoBK account to keep your details ready for upcoming community events.</p>
                        {errorMessage&&<Alert color="danger">{errorMessage}</Alert>}
                        <Form onSubmit={submitRegister}>
                            <FormGroup>
                                <Label>Full Name</Label>
                                <Input 
                                    type = "text"
                                    placeholder = "Full Name"
                                    defaultValue={name}
                                    onChange = {e => setName(e.target.value)}
                                    required
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>Email</Label>
                                <Input 
                                    type = "email"
                                    placeholder = "Requires Unique Email"
                                    defaultValue={email}
                                    onChange = {e => setEmail(e.target.value)}
                                    required
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label for = "password" >Password</Label>
                                <Input 
                                    type = "password"
                                    placeholder = "Password"
                                    defaultValue={password}
                                    onChange = {e => setPassword(e.target.value)}
                                    required
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label for = "password2" >Confirm Password</Label>
                                <Input 
                                    type = "password"
                                    placeholder = "Confirm Password"
                                    defaultValue={password2}
                                    onChange = {e => setPassword2(e.target.value)}
                                    required
                                />
                            </FormGroup>
                            <Button
                                color="primary"
                                className='w-100 mt-4'
                                block
                            >
                                Register
                            </Button>
                        </Form>
                    </ModalBody>
                </Modal>
            </div>
        )
}

export default RegisterModal
